import crawlApi, { type CrawlRequestBody } from './crawlApi';

const getByUrlApi = crawlApi.injectEndpoints({
  endpoints: build => ({
    getAssetByUrl: build.mutation<unknown, CrawlRequestBody>({
      query: (body: CrawlRequestBody) => {
        return {
          url: '/khazesh/v3/assets/get_by_url',
          method: 'POST',
          body: body
        };
      }
    })
  })
});

export const { useGetAssetByUrlMutation } = getByUrlApi;

export default getByUrlApi;
